import classNames from 'classnames'
import { dispatchAmplitudeEvent } from 'src/utils/amplitude'
import type { StandardObject } from 'src/utils/amplitude/types/amplitudeObjects'

import { SuggestionItem } from './SuggestionItem'
import { saveSearchedTerms } from './utils/updateUserSearchedTerms'

type ModalSearchTermsProps = {
  userSearchedTerms: Array<{ term: string }>
  setUserSearchedTerms: (terms: Array<{ term: string }>) => void
  term?: string
  resultNotFound: boolean
  termsToShowAUser: Array<{ term: string }>
  onSearch: (searchTerm?: string) => void
  standardObj: StandardObject | null
}

const ModalSearchTerms = ({
  userSearchedTerms,
  setUserSearchedTerms,
  term,
  resultNotFound,
  termsToShowAUser,
  onSearch,
  standardObj,
}: ModalSearchTermsProps) => {
  const selectDescriptionTerms = () => {
    if (term === '' && !resultNotFound && userSearchedTerms.length === 0) {
      return 'Mais buscados'
    }

    if (userSearchedTerms.length > 0 && term === '') {
      return 'Você já buscou'
    }

    return ''
  }

  const descriptionTerms = selectDescriptionTerms()

  return (
    <div>
      <div className="flex max-w-[662px] items-end pr-4">
        {!!descriptionTerms && (
          <h3
            data-testid="discovery-hub-terms-heading"
            className="mt-8 text-base font-medium desktop-body-regular-text1 text-restructure-primary w-full restructure-small-desktop:text-lg"
          >
            {descriptionTerms}
          </h3>
        )}
        {userSearchedTerms.length > 0 && term === '' && (
          <button
            data-testid="discovery-hub-terms-clear"
            className="desktop-body-semibold-text3 text-restructure-action "
            type="button"
            onClick={() => {
              localStorage.removeItem('searchedTerms')
              setUserSearchedTerms([])
            }}
          >
            Limpar
          </button>
        )}
      </div>
      <ul
        className={classNames(
          'flex mt-6 restructure-small-desktop:mt-[18px] flex-wrap  pb-xxs gap-md',
          {
            'scrollbar-v2  overflow-x-auto restructure-small-desktop:overflow-x-visible':
              term === '' || resultNotFound,
          },
          {
            'restructure-small-desktop:gap-0': term !== '' && !resultNotFound,
          }
        )}
        data-testid="discovery-hub-terms-list"
      >
        {termsToShowAUser
          .slice(0, 4)
          .map((suggestion: { term: string }, index: number) => (
            <li
              key={suggestion.term}
              className={classNames('flex w-fit', {
                'restructure-small-desktop:pl-5 restructure-small-desktop:w-full restructure-small-desktop:hover:bg-[#F1F0ee] restructure-small-desktop:pr-4 restructure-small-desktop:py-[10px]':
                  term !== '' && !resultNotFound,
              })}
            >
              <SuggestionItem
                term={term}
                userSearchedTerms={userSearchedTerms.length > 0}
                label={suggestion.term}
                onClick={() => {
                  saveSearchedTerms(suggestion.term)
                  setUserSearchedTerms([
                    ...userSearchedTerms,
                    { term: suggestion.term },
                  ])
                  onSearch(suggestion.term)
                  dispatchAmplitudeEvent({
                    eventName: 'Click Term',
                    eventData: {
                      ...standardObj,
                      'click name': suggestion.term,
                      'click position': index,
                      'click category': descriptionTerms,
                    },
                  })
                }}
                type={term !== '' && !resultNotFound ? 'list' : 'suggestion'}
              />
            </li>
          ))}
      </ul>
    </div>
  )
}

export default ModalSearchTerms
